import { Component, OnInit } from '@angular/core';
import Content from './content.json';
import { ApiService } from '../../../ozempic-ccr/servicio/api.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['/../../styles/theme.scss']
})
export class HomeComponent implements OnInit {

  constructor(public api: ApiService) { }

  ngOnInit() {
  }

}
